export default __webpack_public_path__ + "static/media/allow-unpaid-orders.500eb46f.svg";